import React from "react";
import { IoIosArrowForward } from "react-icons/io";
import { IoIosArrowBack } from "react-icons/io";

const ThemePagination = ({ activePage, totalPages, setPage }) => {
  const renderPages = () => {
    const pages = [];
    if (totalPages <= 5) {
      // Show all pages if totalPages is 5 or fewer
      for (let i = 1; i <= totalPages; i++) {
        pages.push(
          <p
            className={`m-0 p-0 ${activePage === i && "active"}`}
            key={i}
            onClick={() => setPage(i)}
          >
            {i}
          </p>
        );
      }
    } else {
      // Show first 3, activePage range, and last page with ellipsis
      if (activePage <= 3) {
        for (let i = 1; i <= 5; i++) {
          pages.push(
            <p
              className={`m-0 p-0 ${activePage === i && "active"}`}
              key={i}
              onClick={() => setPage(i)}
            >
              {i}
            </p>
          );
        }
        pages.push(
          <span key="dots-end" className="dots">
            ...
          </span>
        );
        pages.push(
          <p
            className="m-0 p-0"
            key={totalPages}
            onClick={() => setPage(totalPages)}
          >
            {totalPages}
          </p>
        );
      } else if (activePage >= totalPages - 2) {
        pages.push(
          <p className="m-0 p-0" key={1} onClick={() => setPage(1)}>
            1
          </p>
        );
        pages.push(
          <span key="dots-start" className="dots">
            ...
          </span>
        );
        for (let i = totalPages - 4; i <= totalPages; i++) {
          pages.push(
            <p
              className={`m-0 p-0 ${activePage === i && "active"}`}
              key={i}
              onClick={() => setPage(i)}
            >
              {i}
            </p>
          );
        }
      } else {
        pages.push(
          <p className="m-0 p-0" key={1} onClick={() => setPage(1)}>
            1
          </p>
        );
        pages.push(
          <span key="dots-start" className="dots">
            ...
          </span>
        );
        for (let i = activePage - 1; i <= activePage + 1; i++) {
          pages.push(
            <p
              className={`m-0 p-0 ${activePage === i && "active"}`}
              key={i}
              onClick={() => setPage(i)}
            >
              {i}
            </p>
          );
        }
        pages.push(
          <span key="dots-end" className="dots">
            ...
          </span>
        );
        pages.push(
          <p
            className="m-0 p-0"
            key={totalPages}
            onClick={() => setPage(totalPages)}
          >
            {totalPages}
          </p>
        );
      }
    }
    return pages;
  };

  return (
    <div className="theme-pagination d-flex w-100">
      <div className="pagination-box d-flex gap-2 align-items-center ms-auto">
        <div
          className="pagination-icon cursor"
          onClick={() => activePage > 1 && setPage(activePage - 1)}
        >
          <IoIosArrowBack className="icon" />
        </div>
        {renderPages()}
        <div
          className="pagination-icon cursor"
          onClick={() => activePage < totalPages && setPage(activePage + 1)}
        >
          <IoIosArrowForward className="icon" />
        </div>
      </div>
    </div>
  );
};

export default ThemePagination;
